import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { IncomingCallEvent, IncomingCallService } from "src/app/shared/services/incoming-call.service";

/**
 * Spec #1 — Floating queue widget for incoming calls that arrived while the
 * dispatcher was already handling another one. Sits in the corner so the
 * dispatcher never loses sight of waiting callers. Clicking a queued entry
 * promotes it to the active call (the incoming-call modal then opens for it);
 * the X button removes it without answering.
 *
 * Mounted once in the layout shell. Hidden when the queue is empty.
 */
@Component({
  selector: "app-queued-calls-widget",
  templateUrl: "./queued-calls-widget.component.html",
  styleUrl: "./queued-calls-widget.component.scss",
  standalone: false
})
export class QueuedCallsWidgetComponent implements OnInit, OnDestroy {
  queue: IncomingCallEvent[] = [];
  collapsed: boolean = false;
  private sub?: Subscription;

  constructor(private incomingCall: IncomingCallService) {}

  ngOnInit(): void {
    this.sub = this.incomingCall.queue$$().subscribe((q) => (this.queue = q));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  toggle(): void {
    this.collapsed = !this.collapsed;
  }

  answer(call: IncomingCallEvent): void {
    this.incomingCall.answerQueued(call.callId);
  }

  dismiss(call: IncomingCallEvent, ev: Event): void {
    ev.stopPropagation();
    this.incomingCall.dismissQueued(call.callId);
  }

  displayNumber(call: IncomingCallEvent): string {
    return `${call.fromCountryPhoneCode ? call.fromCountryPhoneCode + " " : ""}${call.fromNumber}`;
  }

  /** Seconds the call has been waiting. */
  waitingSec(call: IncomingCallEvent): number {
    return Math.max(0, Math.floor((Date.now() - call.startedAt) / 1000));
  }
}
